import { useEffect, useRef, useState } from "react";
import { useT } from "../lib/i18n";

/**
 * Botón flotante de ayuda (abajo a la derecha) con un panel de recursos. Mismo espíritu que el de
 * otras dApps, pero en español y con la piel cálida de la landing. Incluye el aviso anti-estafa: es
 * el sitio donde más pesa, porque quien busca ayuda es a quien más fácil engañan por privado.
 *
 * TODO: URLs reales. Cuando existan docs/educación/canal de Telegram, se ponen aquí.
 */
const RECURSOS = [
  { t: "Documentación", d: "Cómo funciona la plataforma, en detalle.", url: "#", ext: true },
  { t: "Aprende", d: "Los conceptos y flujos básicos, explicados.", url: "#", ext: true },
  { t: "Telegram", d: "Únete al canal y pregunta a la comunidad.", url: "#", ext: true },
];

export function BotonAyuda() {
  const t = useT();
  const [abierto, setAbierto] = useState(false);
  const caja = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!abierto) return;
    const fuera = (e: MouseEvent) => { if (caja.current && !caja.current.contains(e.target as Node)) setAbierto(false); };
    const esc = (e: KeyboardEvent) => { if (e.key === "Escape") setAbierto(false); };
    document.addEventListener("mousedown", fuera);
    document.addEventListener("keydown", esc);
    return () => { document.removeEventListener("mousedown", fuera); document.removeEventListener("keydown", esc); };
  }, [abierto]);

  return (
    <div className="ayuda" ref={caja}>
      {abierto && (
        <div className="ayuda-panel" role="dialog" aria-label={t("Ayuda")}>
          <p className="ayuda-cab">{t("¿Necesitas ayuda?")}</p>
          <div className="ayuda-lista">
            {RECURSOS.map((r) => (
              <a
                key={r.t}
                className="ayuda-item"
                href={r.url}
                target={r.ext ? "_blank" : undefined}
                rel={r.ext ? "noopener noreferrer" : undefined}
              >
                <span className="ayuda-item-t">{t(r.t)}</span>
                <span className="ayuda-item-d">{t(r.d)}</span>
              </a>
            ))}
          </div>
          <p className="ayuda-aviso">
            {t("Nuestro equipo NUNCA te escribe por privado. Ignora y bloquea cualquier mensaje directo que recibas.")}
          </p>
        </div>
      )}

      <button
        className={`ayuda-fab ${abierto ? "activo" : ""}`}
        onClick={() => setAbierto((v) => !v)}
        aria-expanded={abierto}
      >
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12" y2="17" />
        </svg>
        <span>{t("¿Necesitas ayuda?")}</span>
      </button>
    </div>
  );
}
